<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-15 11:52:54
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-05 17:07:55
 * @FilePath: /chaoyongtuan/src/components/business/addCommanderDrawer/addCommanderDrawer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog
		custom-class="dialog-content"
		:append-to-body="true"
		title="视频号ID"
		:visible.sync="dialogVisible"
		width="400px"
		:before-close="handleClose"
	>
		<el-input placeholder="请输入" v-model="anchor_account"></el-input>
		<span slot="footer">
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="submit" :loading="btnLoading">确认</el-button>
		</span>
	</el-dialog>
</template>
<script>
import throttle from 'lodash/debounce';
import { addAnchor, getAnchorShowcase } from '@/api/talentCRM';
import dataMap from '../../../utils/dataMap';

export default {
	data() {
		return {
			dialogVisible: false,
			btnLoading: false,
			anchor_account: '',
			row: {},
		};
	},
	methods: {
		show(row) {
			console.log(row, 999);
			this.dialogVisible = true;
			this.row = row;
		},
		handleClose() {
			this.dialogVisible = false;
			this.anchor_account = '';
		},
		async checkOpenfinderid() {
			try {
				const res = await getAnchorShowcase({
					tenantId: this.$store.state.vuex_tenantId,
					platformId: dataMap.PLATFORM_SP.value,
					finderId: this.anchor_account,
				});
				if (res?.openfinderid && this.row.openFinderIds === res.openfinderid) {
					return true;
				}
				this.$message.warning('视频号ID校验不通过，请重新填写');
				return false;
			} catch (error) {
				console.log(error);
			}
		},

		submit: throttle(async function () {
			const { anchor_name } = this.row;
			if (!(await this.checkOpenfinderid())) return;
			const params = {
				anchor_account: anchor_name,
				anchor_name: anchor_name,
				cooperate_status: 1,
				platform_id: dataMap.PLATFORM_SP.value,
				remark: '',
				contact_name: '',
				wechat_account: '',
				contact_mobile: '',
				is_sea: 0,
				anchor_uid: this.anchor_account,
			};
			this.btnLoading = true;
			addAnchor(params).then(res => {
				this.btnLoading = false;
				if (res.code === 0) {
					this.$message.success('添加成功');
					this.dialogVisible = false;
					this.$emit('refresh');
				} else {
					this.$message.error(res.msg);
				}
			});
		}, 1000),
	},
};
</script>
<style lang="less" scoped>
</style>
